// extracted by mini-css-extract-plugin
export var growableInput = "_a3-0";
export var tagContainer = "_a3-2";
export var textInput = "_a3-1";